export const previewMockValues = {
  client: {
    name: "株式会社サンプル",
  },
  invoice: {
    date: "令和7年6月24日",
    number: "請求書25-1",
    registration_number: "T7810948913857",
  },
  issuer: {
    qualification: "司法書士",
    business: "",
    business_label: "",
    name: "天野晃浩",
    registration_number: "愛知第000号",
    rules: {
      registration_number: "愛知第000号",
    },
  },
  office: {
    name: "登記測量 長坂・天野合同事務所",
    name_short: "登記測量",
    name_main: "長坂・天野合同事務所",
    postal: "444-0853",
    address: "岡崎市三崎町９番地５",
    tel: "0564-52-8530",
    fax: "0564-51-7996",
  },
  computed: {
    fee_subtotal: 50000,
    tax_subtotal: 10000,
    gross: 60000,
    consumption_tax: 5000,
    withholding_tax: 4105,
    total: 60895,
    adjustment_amount: 0,
  },
  transaction: {
    date: "令和7年1月",
  },
  amount: {
    invoice: 0,
  },
  line_items: [
    {
      item_date: "令和7.6.1",
      description: "抵当権設定登記（不動産1件）",
      fee_amount: 30000,
      tax_amount: 5000,
    },
    {
      item_date: "令和7.6.5",
      description: "所有権移転登記（不動産1件）",
      fee_amount: 20000,
      tax_amount: 5000,
    },
  ],
} satisfies Record<string, unknown>;
